export default {"src":"/_next/static/media/tiktok.f24b80be.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};